import React, { Fragment, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/rootState';
import { Dialog, OperationState } from '../../../store/appState';
import styled from 'styled-components/macro';
import * as Actions from '../../../store/actions';
import { AppPaths } from '../../../constants/urls';
import spaceVS from '../../../config/spaces/spaceVS';
import { useLocation } from 'react-router-dom';
import { updateUrlParams } from '../../../utils/webPage';
import { MyFeedbackComponent } from '../MyFeedback/MyFeedbackView';
import { ResourceStrings } from '../../../ResourceStrings';
import AnnouncementSummary from './AnnouncementSummary';
import { App, SignInState } from '../../../app';
import HeroCard from './HeroCard';
import { Alert } from '../../../AnnouncementInfo';
import { instance } from '../../../config/serverConfig';

export interface HomeViewProps {
}

export default function HomeView(): JSX.Element {
    const state = useSelector((state: RootState) => state.appState);
    const signinState: SignInState = state.signInState;
    const location = useLocation();

    useEffect(() => {
        Actions.setDialog(Dialog.none);
        Actions.loadAnnouncements();
        Actions.loadIncidents();
    }, []);
    const urlParams: URLSearchParams = new URLSearchParams(location.search);
    updateUrlParams(urlParams, { space: spaceVS.id.toString() });

    function incidentClick(url: string): void {
        App.telemetry.postBusinessEvent("announcement-incident-clicked");
        App.openSafe(url);
    }

    return (
        <Wrapper>
            {(state.incidentsLoadState === OperationState.Failed) && <>
                <div className="bar-loading"
                    aria-label={ResourceStrings.errorLoadingIncident(state.incidentErrorMessage)}>
                    {ResourceStrings.errorLoadingIncident(state.incidentErrorMessage)}
                </div>
            </>}

            {(state.incidentsLoadState === OperationState.Success && state.incidents.incidents.length > 0) && <>
                <div className="bar-problems">
                    <span tabIndex={0} aria-label={ResourceStrings.prefixIncidentText()}>{ResourceStrings.prefixIncidentText()}</span>
                    {(state.incidents.incidents || []).map((incident, i) => <Fragment key={i}>
                        <a href={incident.url}
                            key={i}
                            className="a"
                            tabIndex={0}
                            aria-label={incident.title}
                            role="option"> {incident.title}
                        </a>
                        {(i < state.incidents.incidents.length - 1) && <>
                            <span> ,&nbsp;</span>
                        </>}
                    </Fragment>
                    )}
                </div>
            </>}


            {!instance.isInternal && <div className="bar-announcements-container">
                <div className="bar-announcements">
                    {(state.announcementsLoadState === OperationState.Executing) && <>
                        <div className="bar-loading" aria-label={ResourceStrings.loadingAnnouncement()}>
                            {ResourceStrings.loadingAnnouncement()}
                        </div>
                    </>}
                    {(state.announcementsLoadState === OperationState.Failed) && <>
                        <div className="bar-loading" aria-label={ResourceStrings.errorLoadingAnnouncement(state.announcementErrorMessage)}>
                            {ResourceStrings.errorLoadingAnnouncement(state.announcementErrorMessage)}
                        </div>
                    </>}

                    {(state.announcementsLoadState === OperationState.Success && state.announcements.release) && <>
                        <div className="tab-release">
                            <AnnouncementSummary announcement={state.announcements.release} />
                        </div>
                    </>}
                    {(state.announcementsLoadState === OperationState.Success && state.announcements.preview) && <>
                        <div className="tab-preview">
                            {state.announcements.preview && <AnnouncementSummary announcement={state.announcements.preview} />}
                        </div>
                    </>}
                </div>
            </div>}

            {signinState === SignInState.Success && <>
                <div className="myfeedback">
                    <MyFeedbackComponent />
                </div>
            </>}
            {!instance.isInternal && <div>
                <HeroCard title="Find solutions to my problem"
                    info="Check if your problem is already solved or find workarounds"
                    urlTitle="Find solutions"
                    url={`${AppPaths.knownSlugVisualStudio}?ftype=problem`}
                    imageUrl="/images/example1.png" />
                <HeroCard lightBackground reverse title="Request new features"
                    info="Share your ideas for how we can improve the product to better suit your needs"
                    urlTitle="Request new features"
                    url={`${AppPaths.knownSlugVisualStudio}${AppPaths.suggest}`}
                    imageUrl="/images/example1.png" />
                <HeroCard title="Explore existing feature requests"
                    info="Search and filter through existing feedback to cast your vote and share your comments"
                    urlTitle="Explore feature requests"
                    url={`${AppPaths.knownSlugVisualStudio}?ftype=idea`}
                    imageUrl="/images/example1.png" />
            </div>}
        </Wrapper >
    );
}

const Wrapper = styled.main`
    background-color: var(--color-background);
    display: flex;
    flex-direction: column;
    .myfeedback {
        padding: 0 var(--page-margin-horizontal);
    }

    .bar-announcements-container {
        background: var(--color-surface);
        padding: 2.5rem var(--page-margin-horizontal);
        margin-bottom: 3rem;
        min-height: 15rem;
    }

    .bar-announcements {
        display: flex;
        flex-wrap: wrap;
        overflow-x: hidden;

        .tab-preview, .tab-release {
            flex: 1 0 auto;
            padding: 2rem;
            align-self: center;
            text-align: center;
            transform: translateX(-.2rem);
        }

        .tab-preview::before {
            content: "";
            position: absolute;
            background: gray;
            width: .1rem;
            height: 10rem;
            top: calc(50% - 5rem);
            left: 0;
        }
    }

`;